import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
    
import { Tooltip, Typography, Paper, TextField, Button, IconButton, Grid } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import { Application } from '../models/Application';
import { renderField } from 'form-builder';
import { renderCalculations } from 'form-builder';
import { FieldEditor } from 'form-builder';

import { FormTemplate, Field, refreshCalculations, computePaymentSum, computeFutureBalanceSum } from 'form-builder';

import { ThemeColors } from '../Theme'

import { Template } from '../models/Template'
import { DocumentUploaderDownloaderComponent } from "../components/DocumentUploaderDownloaderComponent";
import { ConstantPopover } from '../components/ConstantPopover';
import { CommunityPopover } from '../components/CommunitySelectPopover';
import { Patron } from '../routes/Patron';

import { TextEntryPopover, Currency, hashObj, DateUtils } from 'react-frontend-utils'



export class TemplatePage extends DocumentUploaderDownloaderComponent {

    static reservedPrefixes = ["AGS_", "APP_", "COM_"];

    static reservedPrefixesText = TemplatePage.reservedPrefixes.map(prefix => `"${prefix}"`).join(", ");

    // matches ApplicationConstants in Application.java
    static applicationPreviewConstants = [
        "APP_IS_RNEW",
        "APP_RNEW_MID",
        "APP_RNEW_MTYPE",
        "APP_RNEW_MEMBER_CNT",
        "APP_RNEW_LIM_MEMBER_CNT",
    ];
  
    styles = {
        paperLabel: {
            marginLeft: 5,
            color: 'gray',
            fontSize: '14pt',
            flexGrow: 1
        },
        paper: {
            padding: 10,
            minHeight: 500,
            backgroundColor: ThemeColors.templateGray
        },
        tab: {
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            padding: 6
        },
        roundedContainer: {
            border: '1px solid #CCCCCC', 
            borderRadius: '4px', 
            padding: 10,
            marginBottom: 20
        },
        containerLabel: {
            fontSize: 12, 
            color: 'gray', 
            marginLeft: 5
        },
        table: {
            borderCollapse: 'collapse',
            width: '100%',
            marginBottom: 10,
            marginTop: 10
        },
        tableHeader: {
            borderBottom: '2px solid ' + ThemeColors.appBarBackground,
            textAlign: 'left',
            paddingBottom: 5,
            paddingRight: 10,
            marginBottom: 8,
            fontSize: 13,
            color: ThemeColors.darkGray,
            fontWeight: 'normal',
            textTransform: 'uppercase'
        },
        tableDataWithBorder: {
            textAlign: 'left',
            fontSize: 13,
            paddingRight: 10,
            borderBottom: '1px solid lightGray'
        },
        tableData: {
            textAlign: 'left',
            fontSize: 14,
            paddingRight: 10,
            verticalAlign: 'center',
            height: 42,
            borderBottom: '1px solid lightGray'
        },
        constantsTableData: {
            textAlign: 'left',
            fontSize: 14,
            paddingTop: 4,
            paddingBottom: 4,
            paddingRight: 10,
            verticalAlign: 'middle',
            borderBottom: '1px solid lightGray'
        },
        constantsTableDataDivider: {
            borderTop: '3px solid white'
        },
        constantsEditButton: {
            padding: 4,
            marginRight: 5
        },
        constantsDeleteButton: {
            padding: 4
        },
    };

    _extraFieldCalculationFields = [
        {fieldName: "addsLimitedMembers", title: "Adds Limited Members", tooltip: 'When selected, this calculation value determines the number of Limited Members to add. Should evaluate to a Numeric (integer) value. The attribute defines the Member fields separated by semicolons: "Last;First;Relation".'},
        {fieldName: "incrementsGuestPasses", title: "Increments Guest Passes", tooltip: 'When selected, this calculation value determines how many guest passes to increment for the Membership. These are added after the the number set/incremented in the Community Settings. Should evaluate to a Numeric (integer) value.'},
        {fieldName: "providesDefaultNewMembershipID", title: "Suggests New Membership ID", tooltip: 'When selected, this calculation suggests the Membership ID for a new Membership created from this Application. Should evaluate to a String. Only select this for one calculation, others will be ignored.'},
    ];

    _fieldInClipboard = null;
    
    _fieldEditor = React.createRef();
 
    constructor(props) {
        super(props);
        this.state.templates = [];                  //All available templates
        this.state.selectedTemplateName = "";           //The currently displayed template name (use empty string, Autocomplete barfs on null 
        this.state.selectedTemplateNameValue = "";       
        this.state.creatingNew = false;
        
        this.state.selectedTemplate = null;        //The currently selected Template Object  
                
        this.state.namePopupOpen = false;
        this.state.communityPopupOpen = false;
        this.state.addConstantPopupOpen = false;
        this.state.editConstantName = null;
        
        this.state.fieldToEdit = null;    //The field whose properties are being edited
        
        this.state.tabDisplayed = "Form";
        
        this.state.applicationPreview = null;       //The previewed Application
        this.state.paymentSum = 0.0;                //The calculated payment sum
        this.state.futureBalanceSum = 0.0;          //The calculated future balance sum
        this.state.paymentError = null;             //Error on payment calculation 
        this.state.sampleQueryParams = "";          //Optional query params to seed Preview request
        this.state.overrideConstantValues = {};      //Preview override text values

        this.state.submitTried = false;             //Tried a test submit

        this.state.TemplateHash = "";
    }
    
    
   
    componentDidMount() {
        super.componentDidMount();
        this._fetchAll();
    }
    
    //Fetch all Templates 
    _fetchAll = () => {
        this.setState({tabDisplayed: "Form", creatingNew: false, selectedTemplate: null, selectedTemplateName: "",  selectedTemplateNameValue: "", templateHash: ""}); 
        this._fetchTemplates();
    }
    
    _fetchTemplates = () => {
        
        this.incrementBusy();
        this.secureJSONFetch("/ap/templates", {},
                             this._fetchTemplatesCallback, this._fetchErrorCallback); 
        
    }
   
   
    //Callback for fetching Templates - response is a list of Template objects
    _fetchTemplatesCallback = (response) => {
        if (response) {            
            const templates = response.map(template => new Template(template));
            this.setState({templates: templates});
        }            
        this.decrementBusy();
    }
    

    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }
  
  
    //Sent the template to the server for delete
    _delete = () => {
        if (this.state.selectedTemplate) {
            this.showConfirmAlert("Confirm", 'Really Delete Template "' + this.state.selectedTemplate.name + '"?',
                                  'black', "Cancel", this._deleteTemplate, "Delete", 'red');      
        }
    
    }

    _discard = () => {

        hashObj(this.state.selectedTemplate).then(hash => {
                if (hash !== this.state.templateHash) {
                    this.showConfirmAlert("Confirm", "You have unsaved changes which will be lost. Are you sure?", 
                                            'black', "Cancel", this._confirmDiscard, "Discard Changes", 'red'); 
                }
                else
                    this._confirmDiscard();
        });
    }
    
   _confirmDiscard = () => {
        this._fetchAll();
    }

    _deleteTemplate = () => {
    
        if (this.state.selectedTemplate) {
            this.incrementBusy();
            this.secureJSONFetch("/ap/templates/" + this.state.selectedTemplate.name, {method: "DELETE"},
                             this._deleteCallback, this._fetchErrorCallback); 
            
            
        }
    }
    
    _deleteCallback = () => {
        this.showConfirmAlert("Success", "Template \"" + this.state.selectedTemplate.name + "\" deleted" , 'green'); 
        this.decrementBusy();
        this._fetchAll();
    }
  
  
    //Post the current application to the server for upserting
    _save = () => {
        if (this.state.selectedTemplate) {
        
            console.log("Modifying Template: ", this.state.selectedTemplate);
            this.state.selectedTemplate.prepareForPost();   //prepare the Template for uploading

            this.incrementBusy();
            this.secureJSONFetch("/ap/templates", {method: this.state.creatingNew ? "POST" : "PUT", body: JSON.stringify(this.state.selectedTemplate)},
                             this._saveCallback, this._fetchErrorCallback); 
            
            
        }
    }
    
    
    _saveCallback = () => {
        this.showConfirmAlert("Success", "Template \"" + this.state.selectedTemplate.name + "\" " + (this.state.creatingNew ? "created" : "updated") , 'green'); 
        this.decrementBusy();
        this._fetchAll();
    }

    _assignCommunity = (community) => {
        this.state.selectedTemplate.group = community;
        this.setState({communityPopupOpen: false});
        this.forceUpdate();
    }

    _removeCommunity = () => {
        this.state.selectedTemplate.group = null;
        this.forceUpdate();
    }
  

    
    //Callback when a Template is selected from the available list, fetch the selected Template and all its fields
    _selectTemplate = (event, newValue) => { 
        
        const t = this.state.templates.find(t => t.name === newValue);
        if (!t)
            return;
      
        this.incrementBusy();
        this.secureJSONFetch("/ap/templates/" + t.name, {},
                             this._fetchTemplateCallback, this._fetchErrorCallback); 
        
    }
        
    _fetchTemplateCallback = (response) => {    
        
        if (response) {            
            const template = new Template(response);

            hashObj(template).then(hash => {

                this.setState({ templateHash: hash,
                                selectedTemplateName: template.name, 
                                selectedTemplateNameValue: template.name, 
                                selectedTemplate: template, 
                                creatingNew: false,
                                fieldToEdit: null
                                }); 
            });
                     
        }            
        this.decrementBusy();
    }
    
    
    //Called when editing the field value, and an error occurs
    _fieldInputError = (field, error) => {
        this.showConfirmAlert("Error for Field \"" + field + "\"", error, 'red');
    }
    
    
    _previewTabSelected = () => {
        
        this.setState({applicationPreview: null, paymentSum: 0.0, futureBalanceSum: 0.0, paymentError: null});  //clear old, so tab unmounts

        this.setState({tabDisplayed: "Preview"});
        
        if (this.state.selectedTemplate) {
            console.log("Previewing Template: ", this.state.selectedTemplate);

            this.incrementBusy();
            this.secureJSONFetch("/ap/templates/preview", {method: "POST", body: JSON.stringify(this.state.selectedTemplate)},
                             this._previewCallback, this._fetchErrorCallback, this._normalizePreviewQueryParams()); 
        
        }
        
    }

    _normalizePreviewQueryParams = () => {
        const rawQuery = this.state.sampleQueryParams || "";
        const parsed = queryString.parse(rawQuery, {decode: false});
        const params = [];

        const group = Array.isArray(parsed.group) ? parsed.group[parsed.group.length - 1] : parsed.group;
        const renewID = Array.isArray(parsed.renewID) ? parsed.renewID[parsed.renewID.length - 1] : parsed.renewID;

        if (group)
            params.push("group=" + encodeURIComponent(String(group)));

        if (renewID)
            params.push("renewID=" + encodeURIComponent(String(renewID)));

        const fieldPairs = FormTemplate.getFieldParams(rawQuery);
        fieldPairs.forEach((pair) => {
            params.push("fields=" + encodeURIComponent(String(pair)));
        });

        return params.length > 0 ? "?" + params.join("&") : "";
    }
    
    _previewCallback = (response) => {    
        
        if (response) {            
            const applicationPreview = new Application(response, true); //for patron
            this.setState({applicationPreview: applicationPreview, 
                           overrideConstantValues: TemplatePage._getOverrideConstantValues(applicationPreview.constants)});
            this._previewFieldChanged();  //update all calculations
        }            
        this.decrementBusy();
    }
    
    
    _isEditorOpen = () => {
        return this.state.fieldToEdit != null;
    }

    
    _insertFieldFromClipboard = (parent) => {
        
        if (!this._fieldInClipboard)
            return;  //nothing on clipboard
        
        const insertedField = FormTemplate.insertField(this.state.selectedTemplate.fieldTree, parent, this._fieldInClipboard);
        
        if (this._isEditorOpen())
            this._fieldPropertyEdit(insertedField); //start editing the newly inserted field

        this.forceUpdate();
    }

    _fieldsAdded = (fields) => {
        if (fields.length > 0)
            this._fieldPropertyEdit(fields[0]); //start editing the first newly inserted field
    }
    
    _copyField = (field) => {
        this._fieldInClipboard = FormTemplate.copyField(field);
        console.log(this._fieldInClipboard.name + " is now on the Clipboard");
        this.forceUpdate();
    }

    _fieldMoved = (field) => {
        if (this._isEditorOpen())
            this._fieldPropertyEdit(field); //re-edit the field being moved
    }


    _showUsageMessage = (usages, type, operation, proceedCallback, cancelCallback, otherNote = null) => {
        const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
        const msg = <span>
                        <div>If you {operation} this {type} the following items that reference it will break:</div>
                        <ul>
                            {usages.map((usageItem, index) => <li key={index}>{usageItem}</li>)}
                        </ul>
                        {otherNote ? 
                            <div>{otherNote}</div>
                            : null
                        }
                    </span>

        this.showConfirmAlert(capitalizedType + " in Use", null, 'red', "Cancel", proceedCallback, operation + " Anyway", 'red', msg, cancelCallback);
    }


    //Warn if the field (or, if a group, any of its descendants) is referenced by a calculation before letting the cut/delete proceed
    _confirmFieldUsagesThenProceed = (field, operation, proceedCallback) => {

        const usages = FormTemplate.findFieldSubtreeUsages(this.state.selectedTemplate.fieldTree, this.state.selectedTemplate.fieldCalculations, field);
        if (usages.length > 0)
            this._showUsageMessage(usages, "field", operation, proceedCallback, null);
        else
            proceedCallback();
    }

    _confirmCalculationRename = (usages, callback) => {
        this._showUsageMessage(usages, "calculation", "rename", () => callback(true), () => callback(false));
    }

    _confirmCalculationDelete = (usages, proceedCallback) => {
        this._showUsageMessage(usages, "calculation", "delete", proceedCallback, null);
    }

    _confirmCalculationMove = (usages, proceedCallback) => {
        const otherNote = "Calculations that reference other Calculations must be listed after those referenced.";
        this._showUsageMessage(usages, "calculation", "move", proceedCallback, null, otherNote);
    }



    //Remove the field from the tree and place on Clipboard
    _cutField = (field) => {
        this._confirmFieldUsagesThenProceed(field, "cut", () => this._doCutField(field));
    }

    _doCutField = (field) => {

        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        const removedField = FormTemplate.removeField(this.state.selectedTemplate.fieldTree, field);

        if (removedField) {
            this._fieldInClipboard = removedField;  //place on clipboard
            console.log(this._fieldInClipboard.name + " is now on the Clipboard");
            this.forceUpdate();
        }
        else {
            console.warn("Field \"" + field.name + "\" not found in Template, cannot remove");
        }
    }

    _removeField = (field) => {
        this._confirmFieldUsagesThenProceed(field, "delete", () => this._doRemoveField(field));
    }

    _doRemoveField = (field) => {

        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        FormTemplate.removeField(this.state.selectedTemplate.fieldTree, field);
        this.forceUpdate();
    }
    
    
    //Edit the value of a field
    _formFieldValueChanged = (field, newValue) => {
        console.log("Field \"" + field.name + "\" changing to " + newValue);
        this.forceUpdate();
    }
    
    
    _previewFieldChanged = (field, newValue) => {
        if (field)
            console.log("Field \"" + Field.uniqueFieldName(field) + "\" changing to " + (newValue ? newValue.substring(0, 100) : "null"));
        
        const ap = this.state.applicationPreview;

        refreshCalculations(ap.fieldTree, ap.fieldCalculations, ap.constants, (error) => this.showConfirmAlert("Error in Preview", error, 'red'));

        try {
            const paymentSum = computePaymentSum(ap.fieldTree, ap.fieldCalculations, ap.constants);
            const futureBalanceSum = computeFutureBalanceSum(ap.fieldTree, ap.fieldCalculations, ap.constants);
            this.setState({paymentSum: paymentSum, futureBalanceSum: futureBalanceSum, paymentError: null});
        } catch (error) {
            this.setState({paymentSum: null, futureBalanceSum: null, paymentError: error.toString()});
        }

        this.forceUpdate();
    }

    // Get the display value either quoted string or number
    static _getPreviewConstantDisplayValue = (value) => {
        return typeof value === 'string' ? ('"' + value + '"') : String(value);
    }

    static _getOverrideConstantValues = (constants) => {
        const overrideConstantValues = {};

        TemplatePage.applicationPreviewConstants.forEach((constantName) => {
            const value = constants ? constants.getConstant(constantName) : "";
            overrideConstantValues[constantName] = TemplatePage._getPreviewConstantDisplayValue(value);
        });

        return overrideConstantValues;
    }

    _overrideConstantValueChanged = (constantName, value) => {
        this.setState((prevState) => ({overrideConstantValues: {...prevState.overrideConstantValues, [constantName]: value} }));
    }

    _updatePreviewConstants = () => {
        if (!this.state.applicationPreview)
            return;

        const updatedConstantValues = { ...this.state.overrideConstantValues };

        for (const constantName of TemplatePage.applicationPreviewConstants) {
            const rawValue = updatedConstantValues[constantName] ?? "";
            const trimmedValue = rawValue.trim();

            if (!trimmedValue) {
                this.showConfirmAlert("Preview Constant Error", "Constant \"" + constantName + "\" cannot be blank", 'red');
                return;
            }

            let parsedValue;
            if (trimmedValue.startsWith('"') && trimmedValue.endsWith('"')) {
                parsedValue = trimmedValue.substring(1, trimmedValue.length - 1);
            }
            else {
                const numericValue = Number(trimmedValue);
                if (Number.isNaN(numericValue)) {
                    this.showConfirmAlert("Preview Constant Error", "Constant \"" + constantName + "\" must be a number or a quoted string", 'red');
                    return;
                }
                parsedValue = numericValue;
            }

            const previewConstants = this.state.applicationPreview.constants;
            if (previewConstants.hasConstant(constantName))
                previewConstants.removeConstant(constantName);
            previewConstants.addConstant(constantName, parsedValue);
            updatedConstantValues[constantName] = TemplatePage._getPreviewConstantDisplayValue(parsedValue);
        }

        this.setState({
            applicationPreview: this.state.applicationPreview,
            overrideConstantValues: updatedConstantValues
        }, () => {
            this._previewFieldChanged();
        });
    }
    
    
    
    

    //This function must return an array of available fields, each item in the array having a label, icon, and a callback function.  The callback function should
    //(a) create a new field and (b) call the insertFunction to insert it into the Template 
    _getAvailableFields = (insertFunc) => {
        return Template.getAvailableFields(this.state.selectedTemplate.fieldTree, insertFunc);        
    }

    
    _createNew = () => {
        this.setState({namePopupOpen: true, creatingNew: true, fieldToEdit: null});  //creating new
    }
    
    _copyToNew = () => {
        this.setState({namePopupOpen: true, creatingNew: false});   //just renaming  
    }


    _export= () => {
        if (this.state.selectedTemplate) {
        
            console.log("Exporting Template: ", this.state.selectedTemplate);

            this.secureFileDownload("/ap/templates/" + this.state.selectedTemplate.name + "/export", this.state.selectedTemplate.name + " " + DateUtils.downloadTimeString() + ".json", 
                                    null, 
                                    (error) => this.showConfirmAlert("Error", error, 'red'));      
            
        }
    }


    _import = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            console.log("Selected file " + file.name);

            //Form data has the file as a multipart 
            const formData = new FormData();
            formData.append('file', file);

            this.secureFileUpload("/ap/templates/import",
                file,
                (isDone, status) => {  //always done, only a single response

                    const split = status.split(";");
                    const progressValue = split[0];
                    const errorMessage = split[1]; //error only on failure
            
                    if (progressValue < 0) //error
                        this.showConfirmAlert("Error", errorMessage, 'red');
            
                    else if (progressValue === "100") {
                        this.showConfirmAlert("Success", "Template uploaded, select it from the list to view" , 'green'); 
                        setTimeout(() => this._fetchTemplates());
                    }
                },
                (error) => this.showConfirmAlert("Error", error, 'red'));
        }
        event.target.value = null;  //allow picking of the same value again
    }
    
 
    _nameOkCallback = (name) => {
        
        if (!name) {
            this.showConfirmAlert("Error", "Name cannot be blank", 'red');   
            return;
        }

        const nameRegex = /^[a-zA-Z0-9 _]+$/
        const allowedNameChars = "A-Z a-z 0-9 _ and space";

        if (name.length > 254 || !name.match(nameRegex)) {
            this.showConfirmAlert("Template Name Error", "Name must not be longer than 254 characters, and must contain only the following characters: " + allowedNameChars, 'red');
            return;
        }

        
        if (this.state.creatingNew) {
            const newTemplate = Template.createNew(name);
                   
            this.setState({selectedTemplateName: name, 
                            selectedTemplateNameValue: name, 
                            selectedTemplate: newTemplate, 
                            namePopupOpen: false
                         }); 
        }
        else {  //copy
            this.state.selectedTemplate.copyToNew(name);
            this.setState({namePopupOpen: false, 
                            selectedTemplateName: name, 
                            selectedTemplateNameValue: name,
                            creatingNew: true});  //now we've copied, we are creating a new one          
        }

        hashObj(this.state.selectedTemplate).then(hash => {
                                        this.setState({ templateHash: hash});
                                    });
    }

    _nameCancelCallback = () => {
        this.setState({namePopupOpen: false, tabDisplayed: "Form", creatingNew: false, selectedTemplate: null, selectedTemplateName: "",  selectedTemplateNameValue: ""}); 
    }
    
    _calculationChanged = () => {
        this.forceUpdate();
    }
    
    _getAllCalculationResults = () => {
        //Grab all the computed results and place them in an array so some expressions can reference other results
        const calcResults = [];
        for (const calculation of this.state.selectedTemplate.fieldCalculations)
            calcResults.push({name: calculation.resultName, result: calculation.result});
        
        return calcResults;
    }
    
    
    //Send the expression to the backend to calculate the postfix expression for calculation
    _convertToPostfix = (infixExpression, onConverted) => {
        
        const queryString = "?infix=" + encodeURIComponent(infixExpression);
      
        this.incrementBusy();
        this.secureJSONFetch("/ap/postfix", {},
                             (response) => {this.decrementBusy();
                                            onConverted({result: response.postfixExpression});    //response is a FieldCalculation object
                                           },
                             (error) => {this.decrementBusy();
                                           onConverted({error: error});                                          
                                        },
                             queryString); 
                          
    }
   
    _fieldPropertyEdit = (field) => {
        
        //When first created the FieldEditor component receives the field prop, however since it makes use of uncontrolled components, if the field is changed
        //we must call the fieldPropertyEdit() on its reference to update the field explicity.
        if (this._fieldEditor.current)
            this._fieldEditor.current.fieldPropertyEdit(field);

        this.setState({fieldToEdit: field});        

    }


    _testSubmitApplication = () => {
        
        if (this.state.applicationPreview.isMissingData()) {
            this.showConfirmAlert("Missing Data", "One or more fields are required", 'red');
            this.setState({submitTried: true});
            return;
        }

        if (this.state.applicationPreview.hasErroredField()) {
            this.showConfirmAlert("Missing Data", "One or more fields have an error", 'red');
            this.setState({submitTried: true});
            return;
        }

        const generatedErrors = this.state.applicationPreview.getGeneratedErrors();
        if (generatedErrors && generatedErrors.length > 0) {
            Patron.showGeneratedErrorsAlert(this, generatedErrors);
            this.setState({submitTried: true});
            return;
        }

        
        
        if (this.state.applicationPreview.isTooLarge()) {
            this.showConfirmAlert("Application too Large", "Your Application may be too large, you may need to remove some large attachments", 'red', 'Cancel', this._doSubmit, 'Try Anyway');
            return;
        }

        this.showConfirmAlert("Test Ok", "Application would be accepted", 'green');

    }
    
    _resetSubmit = () => {
        this.setState({submitTried: false});
    }

    _addConstant = () => {
        this.setState({addConstantPopupOpen: true, editConstantName: null});
    }

    _editConstant = (name) => {
        this.setState({
            addConstantPopupOpen: true,
            editConstantName: name
        });
    }

    _addConstantOkCallback = (name, value, description) => {

        this.setState({addConstantPopupOpen: false});

        const editingConstantName = this.state.editConstantName;
        const trimmedName = name ? name.trim() : "";
        if (!trimmedName) {
            this.showConfirmAlert("Constant Name Error", "Constant name cannot be blank", 'red');
            return;
        }

        if (/\s/.test(trimmedName)) {
            this.showConfirmAlert("Constant Name Error", "Constant name cannot contain whitespace", 'red');
            return;
        }

        if (!TemplatePage.canDeleteConstant(trimmedName)) {
            this.showConfirmAlert("Constant Name Error", "Constant name cannot start with reserved prefix " + TemplatePage.reservedPrefixesText, 'red');
            return;
        }

        if (trimmedName.length > 40) {
            this.showConfirmAlert("Constant Name Error", "Constant name cannot exceed 40 characters", 'red');
            return;
        }

        const selectedTemplate = this.state.selectedTemplate;
        const constants = selectedTemplate.constants;

        const trimmedValue = value ? value.trim() : "";

        let valueToStore;
        if (trimmedValue.startsWith('"') && trimmedValue.endsWith('"')) {
            valueToStore = trimmedValue.substring(1, trimmedValue.length - 1);
        }
        else {
            const numericValue = Number(trimmedValue);
            if (trimmedValue === "" || Number.isNaN(numericValue)) {
                this.showConfirmAlert("Constant Value Error", "Value must be a number or a quoted string (\"MyConstant\")", 'red');
                return;
            }
            valueToStore = numericValue;
        }

        if (editingConstantName) {
            if (editingConstantName !== trimmedName && constants.hasConstant(trimmedName)) {
                this.showConfirmAlert("Constant Name Error", "A constant with this name already exists", 'red');
                return;
            }

            constants.removeConstant(editingConstantName);
            constants.addConstant(trimmedName, valueToStore, description);
        }
        else {
            if (!constants.addConstant(trimmedName, valueToStore, description)) {
                this.showConfirmAlert("Constant Name Error", "A constant with this name already exists", 'red');
                return;
            }
        }

        this.setState({selectedTemplate: selectedTemplate, editConstantName: null});
    }

    _deleteConstant = (name) => {
        if (!TemplatePage.canDeleteConstant(name))
            return;

        const selectedTemplate = this.state.selectedTemplate;
        selectedTemplate.constants.removeConstant(name);
        this.setState({selectedTemplate: selectedTemplate});  // force update
    }
    
    static canDeleteConstant = (name) => {
        return !TemplatePage.reservedPrefixes.some(prefix => name.startsWith(prefix));
    }

    static getConstantType = (name) => {
        if (name.startsWith("AGS_"))
            return "Global";

        if (name.startsWith("APP_"))
            return "Application";

        if (name.startsWith("COM_"))
            return "Community";

        return "Template";
    }

    static compareConstants = (aName, bName) => {
        const getSortOrder = (name) => {
            if (name.startsWith("AGS_"))
                return 1;
            if (name.startsWith("COM_"))
                return 2;
            if (name.startsWith("APP_"))
                return 3;
            return 0;       // Template
        };

        const typeDiff = getSortOrder(aName) - getSortOrder(bName);
        if (typeDiff !== 0)
            return typeDiff;

        return aName.localeCompare(bName);
    }


    _renderConstantRow = (name, constant, key, addDivider = false) => {
        const value = constant?.value;
        const description = constant?.description ?? "";

        //Render the header
        if (!name) {
            return (
                <tr key={key} style={this.styles.tableStyle}>
                    <th style={this.styles.tableHeader}>Name</th>
                    <th style={this.styles.tableHeader}>Description</th>
                    <th style={this.styles.tableHeader}>Value</th>
                    <th style={this.styles.tableHeader}>Type</th>
                    <th style={{...this.styles.tableHeader, paddingRight: 0, width: '30px'}}/>
                </tr>
            );
        }

        const cellStyle = addDivider
            ? {...this.styles.constantsTableData, ...this.styles.constantsTableDataDivider}
            : this.styles.constantsTableData;

        return (
            <Fragment key={key}>
                <tr style={this.styles.tableStyle}>
                    
                    <td style={cellStyle}>{name}</td>
                    <td style={cellStyle}>{description}</td>
                    <td style={cellStyle}>{typeof value === 'string' ? `"${value}"` : value}</td>
                    <td style={cellStyle}>{TemplatePage.getConstantType(name)}</td>

                    <td style={{...cellStyle, paddingRight: 0}}>
                        <div style={{display: 'flex', justifyContent: 'right'}}>
                            {TemplatePage.canDeleteConstant(name) ?
                                <Fragment>
                                    <Tooltip title="Edit this Constant">
                                        <IconButton size='small' style={this.styles.constantsEditButton} onClick={() => this._editConstant(name)}>
                                            <EditIcon style={{color: 'gray'}}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete this Constant">
                                        <IconButton size='small' style={this.styles.constantsDeleteButton} onClick={() => this._deleteConstant(name)}>
                                            <DeleteIcon style={{color: 'red'}}/>
                                        </IconButton>
                                    </Tooltip>
                                </Fragment>
                                : null
                            }
                        </div>
                    </td>
                </tr>

            </Fragment>
        );
    }
    
    //------------------------------- RENDER ----------------------------------------------
    
    render() {
       
        const buttonStyle = (activeColor, disabled) => {
            
            let color = disabled ? 'lightGray' : activeColor;
            return {borderColor: color, color: color, maxWidth: 100, textAlign: 'center'};
        };
       
        const showTemplate = this.state.selectedTemplateName || this.state.creatingNew ? true : false;
        const canCreateNew = this.state.creatingNew || this.state.selectedTemplate ? false : true;
        const canDelete = this.state.creatingNew || !this.state.selectedTemplate ? false : true;
                
        const templateNames = this.state.templates.map(template => template.name);
                
        const formRenderParams = {forPatron: false, 
                                  forTemplate: true, 
                                  documentUploader: this.documentUploader,
                                  documentDownloader: this.documentDownloader,
                                  constants: this.state.selectedTemplate ? this.state.selectedTemplate.constants : null,
                                  canEdit: true, 
                                  showFieldName: true,
                                  hasClipboard: true,
                                  onChange: this._formFieldValueChanged, 
                                  cutField: this._cutField,
                                  copyField: this._copyField,
                                  removeField: this._removeField, 
                                  clipboardField: this._fieldInClipboard,
                                  insertFieldFromClipboard: this._insertFieldFromClipboard,
                                  getAvailableFields: this._getAvailableFields,
                                  onFieldPropertyEdit: this._fieldPropertyEdit,
                                  onFieldsAdded: this._fieldsAdded,
                                  fieldMoved: this._fieldMoved,
                                  fieldBeingEdited: this.state.fieldToEdit ? this.state.fieldToEdit.name : null,
                                  onError: this._fieldInputError};
                
        const previewRenderParams = {forPatron: true, 
                                     documentUploader: this.documentUploader,
                                     documentDownloader: this.documentDownloader,
                                     constants: this.state.applicationPreview ? this.state.applicationPreview.constants : null,
                                     onChange: this._previewFieldChanged, 
                                     onError: this._fieldInputError};

        const editConstantValue = this.state.editConstantName
            ? (() => {
                const value = this.state.selectedTemplate?.constants?.getConstant(this.state.editConstantName);
                return typeof value === 'string' ? '"' + value + '"' : String(value);
            })()
            : "";

        const editConstantDescription = this.state.editConstantName
            ? this.state.selectedTemplate?.constants?.getDescription(this.state.editConstantName) ?? ""
            : "";

        const sortedConstants = Array.from((this.state.selectedTemplate?.constants && this.state.selectedTemplate.constants.entries()) || [])
            .sort(([aName], [bName]) => TemplatePage.compareConstants(aName, bName));
                        
                
        return (                        
             <Fragment>
                {this.getConfirmAlertComponent()}
                              
                <TextEntryPopover isOpen={this.state.namePopupOpen} showSkip={false} multiline={false} title="Template Unique Name" 
                                  okCallback={this._nameOkCallback} cancelCallback={this._nameCancelCallback} />

                <ConstantPopover isOpen={this.state.addConstantPopupOpen}
                                 title={this.state.editConstantName ? "Edit Constant" : "Add Constant"}
                                 okLabel={this.state.editConstantName ? "Save" : "OK"}
                                 constantName={this.state.editConstantName ? this.state.editConstantName : ""}
                                 constantValue={editConstantValue}
                                 constantDescription={editConstantDescription}
                                 okCallback={this._addConstantOkCallback}
                                 cancelCallback={() => this.setState({addConstantPopupOpen: false, editConstantName: null})} />

                <CommunityPopover isOpen={this.state.communityPopupOpen} title="Assign Community to Template"
                                  okCallback={this._assignCommunity}
                                  cancelCallback={() => this.setState({communityPopupOpen: false})} />
 
                <div style={{display: 'flex', gap: 20, marginLeft: 10, marginRight: 10, justifyContent: 'left', alignItems: 'center'}}>
                    <Autocomplete
                        size='small'
                        disabled={this.state.selectedTemplate !== null}
                        style={{width: '35%'}}
                        value={this.state.selectedTemplateName}
                        onChange={this._selectTemplate}
                        inputValue={this.state.selectedTemplateNameValue}
                        onInputChange={(event, newValue) => { this.setState({selectedTemplateNameValue: newValue}); }}
                        options={templateNames}
                        blurOnSelect
                        renderInput={(params) => <TextField {...params} label="Templates" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    />            
                
                    <Tooltip title="Save Changes and Refresh">
                        <Button disabled={!showTemplate} fullWidth size='small' style={buttonStyle('green', !showTemplate)} 
                                onClick={this._save} variant="outlined" component="label">
                            Save
                        </Button>
                    </Tooltip> 
                    <Tooltip title="Make a Copy of this Template with a new name">
                        <Button disabled={!showTemplate} fullWidth size='small' style={buttonStyle('blue', !showTemplate)} 
                                onClick={this._copyToNew} variant="outlined" component="label">
                            Copy
                        </Button>
                    </Tooltip>
                    <Tooltip title="Export this Template (last saved version) as a JSON text file">
                        <Button disabled={!showTemplate} fullWidth size='small' style={buttonStyle('blue', !showTemplate)} 
                                onClick={this._export} variant="outlined" component="label">
                            Export
                        </Button>
                    </Tooltip>  
                    <Tooltip title="Close Template (unsaved changes will be lost)">
                        <Button disabled={!showTemplate} fullWidth size='small' style={buttonStyle('black', !showTemplate)} 
                                onClick={this._discard} variant="outlined" component="label">
                            Close
                        </Button>
                    </Tooltip>
                    <Tooltip title="Create a new Template">
                        <Button disabled={!canCreateNew} fullWidth size='small' style={buttonStyle(ThemeColors.addColor, !canCreateNew)}
                                onClick={this._createNew} variant="outlined" component="label">
                            New
                        </Button>
                    </Tooltip> 
                    <Tooltip title="Import Template">
                        <Button disabled={!canCreateNew} fullWidth size='small' style={buttonStyle(ThemeColors.addColor, !canCreateNew)}
                                variant="outlined" component="label">
                            Import
                            <input accept="text/json" style={{display: 'none'}} type="file" onChange={this._import}/>
                        </Button>
                    </Tooltip>                                                       
                    <Tooltip title="Delete Template">
                        <Button disabled={!canDelete} fullWidth size='small' style={buttonStyle('red', !canDelete)}
                        onClick={this._delete} variant="outlined" component="label">
                            Delete
                        </Button>
                    </Tooltip>
                                    
                    {this.state.isBusy ? this.getBusyComponent('right', {marginLeft: 20}, 30) : null}

                </div>
                
                <div style={{marginTop: 15}}/>
                
                {this.state.selectedTemplate ?
                    
                    <div>

                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 15, marginTop: 10, marginBottom: 20, gap: 10}}>
                            <Typography variant="body1" style={{marginRight: 10}}>
                                Assigned Community: {this.state.selectedTemplate.group || "none"}
                            </Typography>
                            <Button size="small" variant="outlined" onClick={() => this.setState({communityPopupOpen: true})}>
                                Assign
                            </Button>
                            <Button size="small" variant="outlined" style={buttonStyle('red')} onClick={this._removeCommunity}>
                                Remove
                            </Button>
                        </div>

                        <div style={{display: 'flex', marginLeft: 20}}>
                            <div style={{...this.styles.tab, backgroundColor: this.state.tabDisplayed === "Form" ? ThemeColors.templateGray : ThemeColors.templateTab}}>
                                <Button fullWidth size='small' onClick={() => this.setState({tabDisplayed: "Form"})} style={{padding: 1}} component="label">
                                    Form
                                </Button>
                            </div>
                            <div style={{...this.styles.tab, marginLeft: 3, backgroundColor: this.state.tabDisplayed === "Calc" ? ThemeColors.templateGray : ThemeColors.templateTab}}>
                                <Button fullWidth size='small' onClick={() => this.setState({tabDisplayed: "Calc"})} style={{padding: 1}} component="label">
                                    Calculations
                                </Button>
                            </div>
                            <div style={{...this.styles.tab, marginLeft: 3, backgroundColor: this.state.tabDisplayed === "Constants" ? ThemeColors.templateGray : ThemeColors.templateTab}}>
                                <Button fullWidth size='small' onClick={() => this.setState({tabDisplayed: "Constants"})} style={{padding: 1}} component="label">
                                    Constants
                                </Button>
                            </div>
                            <div style={{...this.styles.tab, marginLeft: 3, backgroundColor: this.state.tabDisplayed === "Preview" ? ThemeColors.templateGray : ThemeColors.templateTab}}>
                                <Button fullWidth size='small' onClick={this._previewTabSelected} style={{padding: 1}} component="label">
                                    Preview
                                </Button>
                            </div>
                        </div>

                        <Paper style={this.styles.paper}>   
                            <Typography style={this.styles.paperLabel} variant="h6">{(this.state.tabDisplayed === "Preview" ? "Previewing" : "Editing") + " \"" + this.state.selectedTemplate.name + "\""}</Typography> 
                            <div style={{display: this.state.tabDisplayed === "Form" ? 'flex' : 'none'}}>

                                <div style={{width: this.state.fieldToEdit !== null ? '70%' : '100%'}}>
                                    {renderField(this.state.selectedTemplate.fieldTree, 0, formRenderParams)}
                                </div>
                                <div>
                                    {this.state.fieldToEdit !== null ?
                                        <FieldEditor ref={this._fieldEditor} 
                                                     fieldToEdit={this.state.fieldToEdit}
                                                     fieldTree={this.state.selectedTemplate.fieldTree}
                                                     fieldWasEdited={() => this.forceUpdate()}
                                                     stickyTopOffset={50}
                                                     onClose ={() => this.setState({fieldToEdit: null})} />
                                        : 
                                        null
                                    }
                                </div>
                            </div>
                           
                            <div style={{display: this.state.tabDisplayed === "Calc" ? 'block' : 'none'}}>
                                {renderCalculations(this.state.selectedTemplate.fieldCalculations, this._calculationChanged, this.state.selectedTemplate.fieldTree, 
                                    this._convertToPostfix, this._getAllCalculationResults, this._extraFieldCalculationFields, this.state.selectedTemplate.constants,
                                    this._confirmCalculationRename, this._confirmCalculationDelete, this._confirmCalculationMove)}
                            </div>
                            
                            <div style={{display: this.state.tabDisplayed === "Constants" ? 'block' : 'none'}}>
                                <Button fullWidth size='small' style={{...buttonStyle(ThemeColors.addColor), maxWidth: 150, marginTop: 20, marginBottom: 10}}
                                        onClick={this._addConstant}
                                        variant="outlined" component="label">
                                    Add Constant
                                </Button>
                                <table style={this.styles.table}>
                                    <thead>
                                        {this._renderConstantRow(null, 0) /*render header*/ }
                                    </thead>
                                    <tbody>
                                        {sortedConstants
                                            .map(([constantName, constantValue], index) => {
                                                const previousName = index > 0 ? sortedConstants[index - 1][0] : null;
                                                const addDivider = previousName !== null
                                                    && TemplatePage.getConstantType(previousName) === "Template"
                                                    && TemplatePage.getConstantType(constantName) !== "Template";

                                                return this._renderConstantRow(constantName, constantValue, index + 1, addDivider);
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            
                            <div style={{display: this.state.tabDisplayed === "Preview" ? 'block' : 'none'}}>

                                <div style={{marginTop: 10, padding: 10, backgroundColor: 'white', border: '1px solid ' + ThemeColors.templateBorder}}>
                                    <Typography variant="body1" style={{marginBottom: 6, fontWeight: 'bold'}}>Sample Query Parameters</Typography>
                                    <div style={{display: 'flex', alignItems: 'flex-start', gap: 10}}>
                                        <TextField value={this.state.sampleQueryParams}
                                                   onChange={(event) => this.setState({sampleQueryParams: event.target.value ?? ""})}
                                                   variant="outlined"
                                                   fullWidth={true}
                                                   size="small"
                                                   InputLabelProps={{shrink: true}}
                                                   helperText='Example: ?group=sample_pool&field:firstName=Jane&field:lastName=Doe&renewID=12345' />
                                        <Button variant="outlined"
                                                size='small' color="primary" 
                                                onClick={this._previewTabSelected}
                                                style={{minWidth: 140, marginTop: 4}}>
                                            Update Preview
                                        </Button>
                                    </div>
                                </div>

                                <div style={{marginTop: 10, padding: 10, backgroundColor: 'white', border: '1px solid ' + ThemeColors.templateBorder}}>
                                    {this.state.applicationPreview ?
                                        <Fragment>
                                            <Typography variant="body1" style={{marginBottom: 14, fontWeight: 'bold'}}>Application Constant Overrides</Typography>
                                            <Grid container spacing={2}>
                                                {TemplatePage.applicationPreviewConstants.map((constantName) => {
                                                    const currentValue = this.state.overrideConstantValues[constantName] ?? "";
                                                    const hasBlankValue = currentValue.trim() === "";
                                                    const constantDescription = this.state.applicationPreview?.constants?.getDescription(constantName);
                                                    const tooltipDescription = constantDescription && constantDescription.trim()
                                                        ? constantDescription
                                                        : constantName;

                                                    return (
                                                        <Grid key={constantName} item xs={12} sm={6}md={4}>
                                                            <Tooltip title={"Override Constant: " + tooltipDescription}>
                                                                <TextField
                                                                    value={currentValue}
                                                                    label={constantName}
                                                                    onChange={(event) => this._overrideConstantValueChanged(constantName, event.target.value)}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth={true}
                                                                    error={hasBlankValue}
                                                                    InputLabelProps={{shrink: true}}
                                                                />
                                                            </Tooltip>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            <div style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
                                                <Button variant="outlined" color="primary" onClick={this._updatePreviewConstants}>Update Preview</Button>
                                            </div>
                                        </Fragment>
                                        : <Typography align='center' variant="body2" style={{color: 'gray', fontStyle: 'italic'}}>Loading preview constants...</Typography>
                                    }
                                </div>

                                <div style={{marginTop: 10, padding: 10, backgroundColor: 'white', border: '1px solid ' + ThemeColors.templateBorder}}>
                                    {this.state.applicationPreview ? renderField(this.state.applicationPreview.fieldTree, 0, previewRenderParams, this.state.submitTried) : null}
                                </div>

                                <div style={{marginTop: 20, backgroundColor: 'white', border: '1px solid ' + ThemeColors.templateBorder}}>
                                    {this.state.applicationPreview ? 
                                        <div style={{marginTop: 20, marginLeft: 10}}>
                                            <Typography variant="h6" >{"Calculations (" + this.state.applicationPreview.fieldCalculations.length + ")"}</Typography>
                                    
                                            {this.state.applicationPreview.fieldCalculations.map((calc, index) => 
                                                <Typography key={index} style={{marginTop: 5, color: calc.error ? 'red' : 'black'}} variant="body2">{calc.resultName + ": " + (calc.error ? calc.error : calc.result)}</Typography>
                                            )}
                                        </div>                     
                                         : <Typography align='center' variant="h6" style={{marginTop: 20, fontStyle: 'italic', color: 'gray'}}>Generating Preview...</Typography>
                                    }

                                    <Typography variant="h6" style={{marginTop: 20, marginLeft: 10, color: this.state.paymentError ? 'red' : 'black'}}>{"Calculated Payment: " + (this.state.paymentError ? this.state.paymentError : Currency.round(this.state.paymentSum))}</Typography>
                                    {this.state.paymentError ? null :
                                        <Typography variant="h6" style={{marginLeft: 10, color: 'black'}}>{"Calculated Future Balance: " + Currency.round(this.state.futureBalanceSum)}</Typography>
                                    }
                                </div>

                                <div style={{display: 'flex', justifyContent: 'center', gap: 10, marginTop: 20, marginBottom: 30}}>
                                    <Button variant='contained' color='primary' onClick={this._testSubmitApplication}>Test Submit</Button>
                                    <Button variant='outlined' onClick={this._resetSubmit}>Reset</Button>
                                </div>

                            </div>

                        </Paper>
                    </div>
                : null}
                
                
            </Fragment>
        );
        
    }
}


export default withCookies(withRouter(TemplatePage));




